class MegaMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

  document.querySelectorAll('.mega-menu-item').forEach(item => {
    const dropdown = item.querySelector('.mega-menu-dropdown');
    item.addEventListener('mouseenter', () => {
      document.querySelectorAll('.mega-menu-dropdown').forEach(d => d.classList.remove('active'));
      dropdown.classList.add('active');
      document.body.classList.add('mega-menu-active');
    });

    item.addEventListener('mouseleave', () => {
      dropdown.classList.remove('active');
      const anyOpen = document.querySelector('.mega-menu-dropdown.active');
      if (!anyOpen) {
        document.body.classList.remove('mega-menu-active');
      }
    });
  });


    const detailElements = this.querySelectorAll("details");

    detailElements.forEach((details, index) => {
      const summary = details.querySelector("summary");
      const content = details.querySelector(".mega-menu__summary-inner");

      if (!summary || !content) return;

      // Assign unique ID if not already present
      if (!content.id) {
        content.id = `mega-menu-panel-${index}`;
      }

      // Set ARIA attributes
      summary.setAttribute("role", "button");
      summary.setAttribute("aria-controls", content.id);
      summary.setAttribute(
        "aria-expanded",
        details.hasAttribute("open") ? "true" : "false"
      );
      summary.setAttribute("tabindex", "0");

      // Add hover functionality
      details.addEventListener("mouseenter", () => {
        this.openDetails(details);
      });

      details.addEventListener("mouseleave", () => {
        this.closeDetails(details);
      });

      details.addEventListener("click", (event) => {
        const summary = event.target.closest("summary");
        if (!summary) return;

        //event.preventDefault();
         
        if (details.hasAttribute("open")) {
          this.closeDetails(details);
          document.body.classList.remove("mega-menu-open");
        } else {
          this.openDetails(details);
        }
      });
    });

    this.addEventListener("keydown", (event) => {
      if (
        (event.key === "Enter" || event.key === " ") &&
        event.target.matches("summary")
      ) {
        event.preventDefault();
        event.target.click();
      }
    });

    this.updateBodyClass();

    // Expose global function to close the mega menu
    window.closeMegaMenu = () => {
      this.querySelectorAll("details").forEach((details) => {
        this.closeDetails(details);
      });
    };
  }

  openDetails(details) {
    // Close all other details
    this.querySelectorAll("details").forEach((otherDetails) => {
      if (otherDetails !== details) {
        this.closeDetails(otherDetails);
      }
    });

    // Open the specified details
    details.setAttribute("open", "");
    const summary = details.querySelector("summary");
    if (summary) {
      summary.setAttribute("aria-expanded", "true");
    }
    this.updateBodyClass();

    // Update any Swiper instances inside this details element
    // Use requestAnimationFrame to ensure the DOM has updated
    requestAnimationFrame(() => {
      setTimeout(() => {
        const swiperComponents = details.querySelectorAll("swiper-component");
        swiperComponents.forEach((swiperComponent) => {
          // Try to call the updateSwiper method if it exists
          if (typeof swiperComponent.updateSwiper === 'function') {
            swiperComponent.updateSwiper();
          } else {
            // Fallback to direct swiper access
            const swiper = swiperComponent.swiper || swiperComponent.swiperInstance;
            if (swiper && swiper.update) {
              swiper.updateSize();
              swiper.updateSlides();
              swiper.slideTo(0, 0); // Reset to first slide
              swiper.update();
            }
          }
        });
      }, 100);
    });
  }

  closeDetails(details) {
    details.removeAttribute("open");
    const summary = details.querySelector("summary");
    if (summary) {
      summary.setAttribute("aria-expanded", "false");
    }
    this.updateBodyClass();
  }

  updateBodyClass() {
    const anyOpen = this.querySelector("details[open]");
    document.body.classList.toggle("mega-menu-open", !!anyOpen);
  }
}
export default MegaMenu;
